export const UPLOAD_SIZE_LIMIT = 2

type UploadDynamicCompressSourceType = 'jpeg' | 'png'

interface UploadDynamicCompressQualityOptions {
  sizeUpperLimitMB: number
  sizeLowerLimitMB: number
  maxQuality: number
  minQuality: number
}

export const UPLOAD_DYNAMIC_QUALITY_TYPE_WHITELISTS = [
  'image/jpeg',
  'image/jpg',
  'image/png',
]

export const UPLOAD_DYNAMIC_QUALITY_TYPE_SOURCE: Record<
  string,
  UploadDynamicCompressSourceType
> = {
  'image/jpeg': 'jpeg',
  'image/jpg': 'jpeg',
  'image/png': 'png',
}

export const UPLOAD_DYNAMIC_QUALITY_MAP_OPTIONS: Record<
  UploadDynamicCompressSourceType,
  UploadDynamicCompressQualityOptions
> = {
  jpeg: {
    sizeUpperLimitMB: 6.4,
    sizeLowerLimitMB: 2,
    maxQuality: 0.6,
    minQuality: 0.15,
  },
  png: {
    sizeUpperLimitMB: 50,
    sizeLowerLimitMB: 3.5,
    maxQuality: 1,
    minQuality: 0.85,
  },
}
